<app-vista-seguridad>
    <section class="col-md-7 col-sm-12 p-4 rounded bg-white shadow m-auto text-center">
        <header class="mb-4">
            <h2 class="h3">Inicio de sesión</h2>
        </header>
        <form [formGroup]="formLogin" (ngSubmit)="onLogin()">
            <div class="form-row mb-4">
                <div class="col-12 p-0">
                    <input formControlName="username" type="text" class="form-control login-input rounded-0 mb-3 shadow" placeholder="Usuario" />
                </div>
                <div class="col-12 p-0">
                    <input formControlName="password" type="password" class="form-control login-input rounded-0 shadow" placeholder="Contraseña" />
                </div>
            </div>
            <div class="form-row mb-4">
                <div class="col-12">
                    <button type="submit" [disabled]="!formLogin.valid" class="btn text-white login-btn-inicio w-100">Iniciar
                        sesión</button>
                </div>
            </div>
            <div class="form-row mb-4">
                
                <a [routerLink]="['/recuperarContrasena']" class="col text-body"><span>¿Olvido su contraseña?</span></a>
            </div>
        </form>
        <footer class="col-12 pt-4 border-top">
                <a [routerLink]="['/registrar']" class="text-body"><span>¿No tienes cuenta? <strong>Regístrate</strong></span></a>
        </footer>
    </section>
</app-vista-seguridad>
